import ImgCache from '@harrybradshaw/imgcache.js';

let initialised = false;

export function initImageCache(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
        ImgCache.init(() => {
            initialised = true;
            resolve();
        }, reject);
    });
}

export function fetchOrGetFromCache(url: string): Promise<string> {
    if (!initialised) {
        return Promise.resolve(url);
    }
    return isCached(url)
        .then(cached => {
            if (cached) {
                return getUrlForCache(url);
            }
            return cacheFile(url);
        });
}

function isCached(url: string): Promise<boolean> {
    return new Promise<boolean>(resolve => {
        ImgCache.isCached(url, (cachedUrl: string, success: boolean) => {
            resolve(success);
        });
    });
}

function toDataUrl(fileEntry: FileEntry): Promise<string> {
    return new Promise<string>((resolve, reject) => {
        fileEntry.file((file: File) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                resolve(reader.result as string);
            };
            reader.onerror = error => reject(error);
        }, reject);
    });
}

function getUrlForCache(url: string): Promise<string> {
    return new Promise<string>((resolve, reject) => {
        ImgCache.getCachedFile(url, (imgSrc: string, fileEntry: FileEntry) => {
            resolve(toDataUrl(fileEntry));
        }, reject);
    });
}

function cacheFile(url: string): Promise<string> {
    return new Promise<string>((resolve, reject) => {
        ImgCache.cacheFile(url, (cachedUrl: string) => {
            resolve(getUrlForCache(url));
        }, reject);
    });
}
